
export const QUERY__EMPLOYER__SIMPLE_LIST = {
  fields: ['id', 'name', 'state', 'updatedAt'],
  order: ['state ASC', 'name ASC']
};
